export class AppointmentFormFieldKeys {
  constructor() {
    return {
      address: null,
      applicationDate: null,
      // applicationThrough: null,
      birthDate: null,
      // createdBy: null,
      email: null,
      firstName: null,
      lastName: null,
      phone: null,
      azvNumber: null,
      doctorId: null,
      agendaSlotId: null
    };
  }
}